import { Box, Grid, Stack, Typography, styled, Divider } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Header from "../../components/Header";
import { getJobCardData,whoamiAPI } from "../../redux/actions";
import { useAppDispatch } from "../../store/customHooks";
import Fordlogo1 from '../../components/images/Fordlogo1.png';
import moment from "moment";
const useStyles = makeStyles({
    card: {
        boxShadow:
            "inset 4px 4px 6px 0 rgba(153, 166, 206, 0.3), inset -4px -4px 4px 0 #f5f5f5",
        backgroundColor: "white",
        border: "1px solid #ddd",
     //   borderRadius: "8px 8px 0px 0px",

    },
    cardTitle: {
        // backgroundColor: "#1c396d",
        backgroundColor: "#03025d",
        color: "#ffffff",
       // borderRadius: "8px 8px 0 0px"
    },
    cardStatus: {
        // backgroundColor: "#1c396d",
        backgroundColor: "#03025d",
        color: "#ffffff",
        padding: "12px 40px"
    },
    cardContent: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",

        fontWeight: 700,
        fontSize: "16px",
        color: "#2c3968",
        cursor: "pointer",
    },
    logo: {
        width: 72,
        height: 38,
        padding: "20px 10px 20px 0",

    },
    typo: {
        // alignItems:"center",
        // textAlign:"center",
        padding: "10px",
        marginLeft: "40px"
    }
});

const Item = styled(Box)(({ theme }) => ({

    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    flexGrow: 1,
}));
const Dashboard = () => {
    const classes = useStyles();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { docId }: any = useParams()
    useEffect(() => {
        window.onpopstate = function (event) {
            window.history.go(1);
        };
        whoami()
        loadData()
    }, []);

    const [jobCard, setJobCard]: any = useState({})
    const whoami=async()=>{
        await dispatch(whoamiAPI(""))
      }
    const loadData = async () => {
        const payload = { "DocID": parseInt(docId) }
        const res: any = await dispatch(getJobCardData(payload));
        if (res?.payload?.statusCode === 200) {
            setJobCard(res.payload?.data[0]);
        }

    }

    return (
        <Grid container justifyContent={'center'}>
            {/* <Header position={'static'} /> */}
            <Grid item xs={12} sm={6} md={6} lg={6} className={classes.card} >
                <Grid container className={classes.cardTitle} textAlign={'center'} flexDirection={{ xs: 'column', lg: "row" }}>
                    <Grid item sm={12} lg={4} alignItems={'center'}><img src={Fordlogo1} className={classes.logo} alt="fordlog" /></Grid>
                    <Grid item sm={12} lg={8}><Typography variant="h5" textAlign={'center'} color="#fff" className=
                        {classes.typo} >{jobCard?.DealerName}</Typography> </Grid>

                </Grid>

                <Stack spacing={{ xs: 1, sm: 2 }} direction="row">
                    <Item width={50}>
                        <Typography variant="subtitle2" textAlign={'left'}><b>Owner Name</b></Typography>

                    </Item>
                    <Item width={50}>
                        <Typography variant="subtitle2" textAlign={
                            'left'
                        }>{jobCard?.FirstName + " " + jobCard?.LastName}</Typography>
                    </Item>

                </Stack>
                <Divider />

                <Stack spacing={{ xs: 1, sm: 2 }} direction="row">
                    <Item width={50}>
                        <Typography variant="subtitle2" textAlign={'left'}><b>Registration Number</b></Typography>

                    </Item>
                    <Item width={50}>
                        <Typography variant="subtitle2" textAlign={
                            'left'
                        }>{jobCard?.RegistrationNo}</Typography>
                    </Item>

                </Stack>
                <Divider />

                <Stack spacing={{ xs: 1, sm: 2 }} direction="row">
                    <Item width={50}>
                        <Typography variant="subtitle2" textAlign={'left'}><b>Model</b></Typography>

                    </Item>
                    <Item width={50}>
                        <Typography variant="subtitle2" textAlign={
                            'left'
                        }>{jobCard?.Model}</Typography>
                    </Item>

                </Stack>
                <Divider />

                <Stack spacing={{ xs: 1, sm: 2 }} direction="row">
                    <Item width={50}>
                        <Typography variant="subtitle2" textAlign={'left'}><b>Service Type</b></Typography>

                    </Item>
                    <Item width={50}>
                        <Typography variant="subtitle2" textAlign={
                            'left'
                        }>{jobCard?.ServiceType}</Typography>
                    </Item>

                </Stack>
                <Divider />


                <Stack spacing={{ xs: 1, sm: 2 }} direction="row">
                    <Item width={50}>
                        <Typography variant="subtitle2" textAlign={'left'}><b>Promised Delivery Date & Time</b></Typography>

                    </Item>
                    <Item width={50}>
                        <Typography variant="subtitle2" textAlign={
                            'left'
                        }>{moment(jobCard?.PromisedDeliveryDateAndTime).format("DD/MM/YYYY HH:mm")}</Typography>
                    </Item>

                </Stack>
                <Divider />
                <Stack spacing={{ xs: 1, sm: 2 }} direction="row">
                    <Item width={50}>
                        <Typography variant="subtitle2" textAlign={'left'}><b>Estimated Service Cost</b></Typography>

                    </Item>
                    <Item width={50}>
                        <Typography variant="subtitle2" textAlign={
                            'left'
                        }>{jobCard?.EstimatedServiceCost}</Typography>
                    </Item>

                </Stack>
                <Divider />
                <Stack spacing={{ xs: 1, sm: 2 }} direction="row">
                    <Item width={50}>
                        <Typography variant="subtitle2" textAlign={'left'}><b>Service Advisor Name</b></Typography>

                    </Item>
                    <Item width={50}>
                        <Typography variant="subtitle2" textAlign={
                            'left'
                        }>{jobCard?.ServiceAdvisorName}</Typography>
                    </Item>

                </Stack>
                <Divider />

                <Stack spacing={{ xs: 1, sm: 2 }} direction="row">
                    <Item width={50}>
                        <Typography variant="subtitle2" textAlign={'left'}><b>Service Advisor Number</b></Typography>

                    </Item>
                    <Item width={50}>
                        <Typography variant="subtitle2" textAlign={
                            'left'
                        }>{jobCard?.ServiceAdvisorMobileNo}</Typography>
                    </Item>

                </Stack>
                <Divider />
                {/* <Stack spacing={{ xs: 1, sm: 2 }} direction="row">
                    <Item width={50}>
                        <Typography variant="subtitle2" textAlign={'left'}><b>Vehicle status</b></Typography>
                    </Item>
                    <Item width={50}>
                        <Typography variant="subtitle2" textAlign={
                            'left'
                        }>{jobCard.VehicleStatus}</Typography>
                    </Item>

                </Stack> */}
                <Divider />


                <Stack className={classes.cardStatus}><Item><Typography color="#fff">{jobCard?.VehicleStatus}</Typography></Item></Stack>
            </Grid>
        </Grid>
    );
};

export default Dashboard;
